<template>
  <div
    class="d-flex flex-column align-center justify-center"
  >
    <v-form
      v-if="!isSuccess"
      ref="form"
    >
      <div
        class="d-flex flex-column ga-3 pa-7 mt-5 mb-5"
        style="border-radius: 6px; border: 1px solid #ccc"
      >
        <div class="d-flex align-center justify-space-between">
          <img
            src="@/assets/AWD_logo_horizontal_RGB.png"
            style="max-width: 300px;"
          >
          <div class="d-flex flex-column">
            <span>Tel: 905-850-7541</span>
            <span>Fax: 905-850-6090</span>
            <span>Web: <a href="https://www.aluminumwindowdesigns.com">aluminumwindowdesigns.com</a></span>
            <span>440 Hanlan Road, Woodbridge, ON, L4L 3P6</span>
          </div>
        </div>
        <div class="d-flex align-center ga-1">
          <span
            class="fw500 f5"
          >{{ item && item.id ? item.id : '' }} - Service Request</span>
        </div>
        <div class="d-flex flex-column ga-2">
          <div class="d-flex align-center ga-1">
            <v-icon style="font-size: 25px; color: #000">
              mdi-message-arrow-right-outline
            </v-icon>
            <span
              class="fw500 f7"
            >Send a message</span>
          </div>
          <VueEditor
            v-model="form.text"
            :editor-toolbar="customToolbar"
          />
          <div class="d-flex justify-end ga-2">
            <!-- <v-btn
              @click="cancel"
            >
              Cancel
            </v-btn> -->
            <v-btn
              color="primary"
              :loading="loading"
              @click="submit"
            >
              SUBMIT
            </v-btn>
          </div>
        </div>

        <div
          style="border: 1px solid rgb(228, 228, 231); border-radius: 10px;"
          class="d-flex flex-column ga-5 pa-5"
        >
          <div class="d-flex align-center ga-1">
            <v-icon style="font-size: 25px; color: #000">
              mdi-message-outline
            </v-icon>
            <span
              class="fw500 f7"
            >Communications ({{ notifications.length }})</span>
          </div>
          <div
            v-if="notifications && notifications.length > 0"
            class="d-flex flex-column ga-2"
          >
            <div
              v-for="notification in notifications"
              :key="notification.id"
              style="border: 1px solid rgb(228, 228, 231); border-radius: 10px;"
              class="d-flex flex-column ga-2 pa-3"
            >
              <div class="d-flex justify-space-between">
                <div class="d-flex align-center ga-2">
                  <v-chip
                    small
                    outlined
                    :color="notification.type.color"
                  >
                    <span style="text-transform: uppercase">{{ notification.type ? notification.type.name : '' }}</span>
                  </v-chip>
                  <span class="fw600"> {{ notification.is_client == 0 ? notification.user ? notification.user.first_name + ' ' + notification.user.last_name : item.contact_name : item.contact_name }}</span>
                  <span> {{ notification.is_client == 0 ? notification.user ? notification.user.email : item.contact_email : item.contact_email }}</span>
                </div>
                <span> {{ notification.created_at_short }}</span>
              </div>
              <div class="d-flex align-center ga-2">
                <span
                  style="max-width: 1500px; width: 1000px; overflow-y: auto;"
                  v-html="notification.text"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-form>
    <div
      v-else
      class="d-flex flex-column ga-3 pa-7 mt-5 mb-5"
      style="border-radius: 6px; border: 1px solid #ccc; min-width: 800px; max-width: 1000px;"
    >
      <div class="d-flex align-center justify-space-between">
        <img
          src="@/assets/AWD_logo_horizontal_RGB.png"
          style="max-width: 300px;"
        >
        <div class="d-flex flex-column">
          <span>Tel: 905-850-7541</span>
          <span>Fax: 905-850-6090</span>
          <span>Web: <a href="https://www.aluminumwindowdesigns.com">aluminumwindowdesigns.com</a></span>
          <span>440 Hanlan Road, Woodbridge, ON, L4L 3P6</span>
        </div>
      </div>
      <div
        class="d-flex flex-column align-center justify-center pa-5 ga-3"
      >
        <span class="f2 fw600">Thank you</span>
        <span class="f6 fw600 text-center">
          Your message has been sent successfully
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { VueEditor } from 'vue2-editor';

export default {
  components: {
    VueEditor,
  },
  props: {

  },
  data: () => ({
    form: null,
    item: null,
    defaultForm: {
      text: null,
    },
    notifications: [],
    attachments: [],
    attachmentTypeIdSTMS: 5,
    isSuccess: false,
    requestId: null,
    loading: false,
    typeIdEmail: 2,
    typeIdStatusChange: 4,
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' },
      ],
      [{ color: [] }],
    ],
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.form = { ...this.defaultForm };
    this.requestId = this.$route.params.id;
    if (!this.requestId) {
      return;
    }
    this.init();
  },
  methods: {
    init() {
      this.get(this.requestId);
      this.getNotifications();
    },

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.stmsRequest.read(submitModel, null, 'read-unauthorized');
      if (!res || !res.data || res.data.length < 1) return;
      const firstIndex = 0;
      this.item = res.data[firstIndex];
    },

    async getNotifications() {
      const typeIdEmail = 2;
      const submitModel = {
        filters: {
          request_id: this.requestId,
          type_ids: [typeIdEmail, this.typeIdStatusChange],
          is_visible_user: 0,
          is_visible_client: 1,
        },
      };
      const res = await this.$api.stmsRequestNotification.read(submitModel, null, 'read-unauthorized');
      if (!res || !res.data || res.data.length < 1) return;
      this.notifications = res.data;
    },

    async submit() {
      this.loading = true;
      const submitData = {
        stms_request_id: this.item.id,
        text: this.form.text,
        type_id: this.typeIdEmail,
        is_client: 1,
      };

      const res = await this.$api.stmsRequestNotification.store(submitData);
      this.loading = false;

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.isSuccess = true;
    },

    async getAddressData(addressData, placeData) {
      this.form.address = placeData.address;
    },
  },
};
</script>

<style scoped>
.outer-div{
  display: flex;
  gap: 20px;
  width: 100%;

}

.inner-div{
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

}

</style>
